var _style, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeriudha01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000144305405312921445750000003639401208468657315_);}\r\n\t.st1{fill:#1F2835;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 88.15,
    y: 99.67,
    width: 903.46,
    height: 902.23
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025442084652161656400000011417800852098221485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000025442084652161656400000011417800852098221485_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5636",
    className: "st1",
    d: "M857.34,328.52c-0.19-5.12-2.28-9.98-5.85-13.64c-5.85-5.44-11.18-11.18-16.51-16.62 c-23.39-25.26-49.21-48.16-77.08-68.36c-82.66-59.24-186.12-81.71-285.92-62.1C317.65,190.28,193.5,306.24,160.55,458.69 c-50.26,209.1,78.5,419.36,287.6,469.62c203.61,48.94,409.47-71.91,465.97-273.55c3.39-12.53,5.85-25.05,8.02-37.28 c0.7-4.21,1.52-8.31,2.34-12.53c2.43-14.15,14.29-24.75,28.62-25.58h3.28c16.16,0.45,28.89,13.9,28.45,30.06 c-0.02,0.65-0.06,1.31-0.12,1.96c-4.55,44-16.77,86.87-36.11,126.66c-59.08,133.52-180.44,229.12-324.08,255.3 c-28.93,5.59-58.33,8.41-87.79,8.43c-208.78-0.39-389.78-144.55-436.86-347.96C76.19,551.67,88.4,444.49,134.45,350.29 c46.22-93.44,123.39-167.98,218.37-210.94c57.57-26.16,120.08-39.67,183.31-39.62c121.67,0.27,238.18,49.21,323.55,135.9 c7.49,7.49,15.1,15.1,22.48,22.59l24.76,25.05L930.33,268v-40.27c0-23.41,0-46.82,0-70.53c0.07-13.33,9.14-24.93,22.07-28.21 c2.87-0.82,5.85-1.23,8.84-1.23c9.91-0.44,19.29,4.51,24.52,12.93c3.31,5.28,5.18,11.33,5.44,17.56 c0.7,75.03,0.53,151.01,0,221.94c0.34,15.83-11.98,29.06-27.8,29.85c-7.18,0.91-14.42,1.36-21.66,1.35h-199 c-16.17,1.62-30.77-9.69-33.24-25.75c-1.62-8.7,0.67-17.67,6.26-24.52c5.07-6.56,12.84-10.46,21.13-10.59 c11.71-0.41,24.35-0.53,40.97-0.53h45.77h37.11L857.34,328.52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5637",
    className: "st1",
    d: "M505.23,453.77v-40.44c0-24.52,0-49.87,0-74.74c0.06-14.53,10.78-26.82,25.17-28.85 c1.52,0,2.98,0,4.51,0c13.65-0.44,25.86,8.43,29.67,21.54c1.2,4.58,1.75,9.31,1.64,14.05c0,54.72,0,113.43,0,170.5 c-0.4,12.75,6.14,24.71,17.09,31.25c31.02,20.43,63.97,42.08,95.87,64.38c8.09,5.61,13.07,14.69,13.46,24.52 c0.32,9.71-4.04,18.98-11.71,24.93c-4.94,4.08-11.15,6.3-17.56,6.26c-7.34-0.27-14.45-2.69-20.43-6.97l-41.79-28.21l-0.29-0.94 c-24.93-16.86-50.8-34.3-76.56-51.04c-13.06-7.01-20.63-21.18-19.2-35.94c0.7-23.41,0.53-46.41,0.41-69.06L505.23,453.77z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriudha01);
export default __webpack_public_path__ + "static/media/periudha-01.6ad1f15795e9acf0ad70625996757b51.svg";
export { ForwardRef as ReactComponent };